export const TOOLBAR_OPEN_BUTTON_LABEL = 'toolbar.open-button-label';
